export { RichText } from "./rich-text.component";